





















































































import { Watch, Component, Prop, Vue } from 'vue-property-decorator'
import { Referral } from '@/api/model/referral'
import { Project } from '@/api/model/project'
import { ProjectAPI, ReferralAPI } from '@/api/backend-client'
import { v4 as uuid } from 'uuid'
import { escapeHtml } from '@/helpers/html'

@Component
export default class LinkExternalProjectModal extends Vue {
    @Prop({ required: true }) readonly referral!: Referral
    visible: boolean = false
    loading: boolean = false
    projects: Project[] = []
    project: Project = null
    projectName: string = null
    buildNumber: string = null
    copyType: string = null

    @Watch('copyType')
    onCopyTypeChanged(): void {
        this.buildNumber = this.referral.buildNumber
        this.projectName = null
        this.project = null

        if (this.copyType === 'auto') {
            this.projectName = this.referral.project.name

            // If a project already exists, select that one.
            if (this.projects.some(project => project.name === this.projectName)) {
                this.project = this.projects.find(project => project.name === this.projectName)
                this.projectName = null
            }
        }
    }

    async mounted(): Promise<void> {
        await this.loadProjects()
        this.visible = true
    }

    async loadProjects(): Promise<void> {
        this.projects = await ProjectAPI.getAll({
            company: this.$currentCompany.id,
        })

        this.projects = this.projects.sort((a: Project, b: Project) => a.name.localeCompare(b.name))
    }

    async linkExternalProject(): Promise<void> {
        try {
            this.loading = true

            if (this.project === null) {
                this.project = await ProjectAPI.create(Project.fromData({
                    company: this.$currentCompany.resourceIdentifier,
                    id: uuid(),
                    name: this.projectName,
                    active: true,
                }))
            }

            this.referral.assigneeProject = this.project
            this.referral.assigneeBuildNumber = this.buildNumber
            await ReferralAPI.update(this.referral.id, this.referral)

            // Need hard refresh for manually added (to refresh projects)
            if (this.copyType === 'new') {
                window.location.reload()
            }

            this.$emit('on-save', this.referral)
            this.hideModal()

        } catch (error) {
            console.error(error)

            this.$notify({
                type: 'error',
                title: this.$t('error.title').toString(),
                text: this.$t('error.text', { message: escapeHtml(error.message) }).toString().replace(/\n/g, '<br>'),
            })

        } finally {
            this.loading = false
        }
    }

    showModal(): void {
        this.visible = true
    }

    hideModal(): void {
        this.visible = false
    }

    get isNameAlreadyTaken(): boolean {
        if (!this.projectName) {
            return false
        }

        return this.projects.some(project => project.name === this.projectName)
    }

    get copyOptions() {
        return ['auto', 'manual', 'new'].map(option => {
            return {
                label: this.$t(`referral.link-external-project.copy.${option}`),
                value: option,
            }
        })
    }
}
